import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, SectionHead } from "./Reveal";

const Faq = () => {
  const { t } = useLanguage();
  const items = t("faq.items");

  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <SectionHead eyebrow={t("faq.eyebrow")} title={t("faq.title")} align="center" />
      <Reveal delay={0.1} className="mt-12">
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="overflow-hidden rounded-2xl border border-white/[0.07] bg-panel px-6 transition-colors data-[state=open]:border-gold/35"
            >
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-5 text-start font-display text-lg font-semibold text-white hover:text-gold hover:no-underline [&[data-state=open]]:text-gold"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="pb-6 text-sm leading-relaxed text-slate-400">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
};

export default Faq;
